import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Authentication } from '../../providers/authentication';
import { ValidationService } from '../../services/validation';
import { TEXT_MASKS } from '../../constants';
import { SigninComponent } from '../signin/signin';
import { ForgotPasswordComponent } from '../forgot_password/forgot_password'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';

@Component({
  selector: 'signup-page',
  styleUrls: ['./signup.scss'],
  templateUrl: './signup.pug'
})

export class SignupComponent {
  public clientForm: FormGroup;
  public textMasks = TEXT_MASKS;
  public submitted: boolean;
  public signUpErrors: Object;
  passwordShown: boolean = false;

  constructor(public authService: Authentication,
              public toastr: ToastsManager,
              private router: Router,
              private modalService: NgbModal,
              private _fb: FormBuilder) {}

  ngOnInit(){
    this.clientForm = this._fb.group(this.formInit());
  }

  submitForm() {
    this.submitted = true;
    if(this.clientForm.valid) {
      this.formatPhoneValue();
      this.signUp();
    }
  }

  formatPhoneValue() {
    let phone = this.clientForm.controls['phone_number']
    phone.setValue(phone.value.replace(/\D/g, ''))
  }

  formInit() {
    const user = {
      last_name: ['', Validators.compose([Validators.required, Validators.maxLength(25)])],
      first_name: ['', Validators.compose([Validators.required, Validators.maxLength(25)])],
      phone_number: ['', Validators.compose([Validators.required, ValidationService.minFilteredLength(10)])],
      email: ['', Validators.compose([Validators.required, ValidationService.emailValidator])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])]
    };
    return user;
  }

  signUp() {
    this.authService.signUp({client: this.clientForm.value}).subscribe((data) => {
      this.authService.setUser(data['user']);
      this.router.navigate(['./'])
      this.toastr.success('You signed up successfully!');
    }, (err) => {
      this.signUpErrors = JSON.parse(err['_body'])['errors'];
      this.clientForm.markAsPristine();
      this.toastr.info('Sign up failed!');
    });
  }

  openSignIn() {
    const modalRef = this.modalService.open(SigninComponent, { windowClass: 'signin-modal' });
    modalRef.result.then((data) => {
      if(data == 'forgot password') {
        this.openForgotPassword();
      }
    }, () => {});
  }

  openForgotPassword() {
    this.modalService.open(ForgotPasswordComponent, { windowClass: 'signin-modal forgot-password-modal' });
  }

  showPassword(input: any): any {
    input.type = input.type === 'password' ?  'text' : 'password';
    this.passwordShown = !this.passwordShown;
  }
}



// WEBPACK FOOTER //
// ./src/components/signup/signup.ts